import React from "react";
import Hero from "../comps/Hero/Hero";
import CoinList from "../comps/CoinList/CoinList";

const Home = () => {
  return (
    <div>
      <Hero />
      <CoinList />
    </div>
  );
};

export default Home;
